module.exports = __webpack_public_path__ + "assets/roboto-italic.af11b5fbed436462a89361de50719676d05d65f114d1aabf6931b505a18917de.woff";